// Letter values (docs/02-Game-Design/Scoring.md): tiers per language, a
// per-language constant of the rules engine. English comes from letter
// frequency, 5 + 5.8306 × ln(freq E / freq letter) rounded; the doc has the
// frequencies and how to retune the constant. German: starting values, to tune.
import type { Lang } from '../level/schema';

function tiers(table: Record<number, string>): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [points, letters] of Object.entries(table)) {
    for (const letter of letters.split(' ')) out[letter] = Number(points);
  }
  return out;
}

export const LETTER_VALUES: Record<Lang, Record<string, number>> = {
  en: tiers({
    5: 'E',
    7: 'T A',
    8: 'O I N',
    9: 'S R H',
    11: 'D L',
    13: 'U',
    14: 'C M',
    15: 'F Y W G',
    16: 'P',
    17: 'B',
    19: 'V',
    22: 'K',
    30: 'X',
    32: 'Q',
    33: 'J',
    35: 'Z',
  }),
  de: tiers({
    5: 'E N I S R A T',
    6: 'D H U L C G',
    7: 'M O B W F K',
    8: 'Z P V',
    10: 'Ä Ö Ü ẞ J',
    12: 'Y X Q',
  }),
};

export const BASE_LETTER_VALUE = 5;

export function letterValue(lang: Lang, letter: string): number {
  return LETTER_VALUES[lang][letter] ?? BASE_LETTER_VALUE;
}
